"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pfilter = void 0;
var type_system_1 = require("../../../type_system/index.js");
var bool_1 = require("../../builtins/bool/index.js");
var papp_1 = require("../../papp.js");
var pfn_1 = require("../../pfn.js");
var phoist_1 = require("../../phoist.js");
var plam_1 = require("../../plam.js");
var const_1 = require("./const/index.js");
var pfoldr_1 = require("./pfoldr/index.js");
function pfilter(elemsT) {
    return (0, phoist_1.phoist)((0, plam_1.plam)((0, type_system_1.lam)(elemsT, type_system_1.bool), (0, type_system_1.lam)((0, type_system_1.list)(elemsT), (0, type_system_1.list)(elemsT)))(function (predicate) {
        return (0, pfoldr_1.pfoldr)(elemsT, (0, type_system_1.list)(elemsT))
            .$((0, pfn_1.pfn)([
            elemsT,
            (0, type_system_1.list)(elemsT)
        ], (0, type_system_1.list)(elemsT))(function (elem, accum) {
            return (0, bool_1.pif)((0, type_system_1.list)(elemsT)).$((0, papp_1.papp)(predicate, elem))
                .then(accum.prepend(elem))
                .else(accum);
        })).$((0, const_1.pnil)(elemsT));
    }
    // .$( lst )
    , "pfilter"));
}
exports.pfilter = pfilter;
